/* eslint no-param-reassign: "off", no-console: "off" */
import Vuex from 'vuex';
import ApiClientStore from './stores/apiclient-store';
import AppSettingsStore from './stores/appsettings-store';

const userStore = {
  state: {
    user: { account: {} }
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    async fetchMe({ commit }) {
      try {
        const res = await fetch('/v2/users/me');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('setUser', data);
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    }
  },
  getters: {
    user: state => state.user,
    permissions: state => {
      if (!state.user.permissions) return [];
      return state.user.permissions.map(p => p.toLowerCase()).sort();
    }
  },
  modules: {
    apiclients: ApiClientStore,
    settings: AppSettingsStore
  }
}
export default userStore;
export const useUserStore = () => new Vuex.Store(userStore);
